import BaseLayout from '../../layout/BaseLayout';
import {NotFound} from './NotFound';

export function NotFoundPage() {
  return (
    <BaseLayout transparentBackground>
      <NotFound />
    </BaseLayout>
  );
}
